<script>
    import IconClock from '@/common/assets/img/clock.svg';
    import IconTel from '@/assets/img/phone.svg';

    export default {
        name: 'CardCalendar',
        props: ['item'],
        data() {
            return {
                IconClock: IconClock,
                IconTel: IconTel
            }
        },
        methods: {
            getTypeBadgeClass (type) {
                switch (type) {
                case 'Visio Call':
                    return 'card-calendar__type-badge--visio'
                case 'Rendez-vous':
                    return 'card-calendar__type-badge--rdv'
                case 'Appel téléphonique':
                    return 'card-calendar__type-badge--phone'
                default:
                    return ''
                }
            }
        }
    }
</script>
<template>
	<article class="card-calendar dashboard-card dashboard-card--bordered dashboard-card--hoverable">
		<router-link :to="{ name: 'Client', params: { clientId: item.clientId } }">			
		<div class="card-calendar__wrapper">
				<div class="card-calendar__time">
					<img :src="IconClock" alt="" class="card-calendar__icon">
					<time :datetime="item.datetime || ''">{{ $moment(item.hour.start).format('HH:mm') }}</time>
				</div>
				<div class="card-calendar__content">
					<div class="card-calendar__header">
						<h4 class="dashboard-card__name">{{ item.customer  }}</h4>
						<span class="card-calendar__type-badge" :class="getTypeBadgeClass(item.type)">{{ item.type }}</span>
					</div>
					<p class="card-calendar__subject">{{ item.description }}</p>
				</div>
				<svg class="dashboard-card__arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
					<path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
		</router-link>
	</article>
</template>

<style scoped>
.card-calendar__wrapper {
	display: flex;
	gap: 1rem;
	align-items: center;
}

a {
	text-decoration: none;
	color: inherit;
	display: block;
}

.card-calendar__time {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.25rem;
	min-width: 60px;
	padding: 0.5rem 0.75rem;
	background:var(--light-grey);
	border-radius: 8px;
	color: black;
	font-weight: 700;
	font-size: 0.875rem;
}

.card-calendar__icon {
	width: 16px;
	height: 16px;
	opacity: 0.8;
}

.card-calendar__content {
	flex: 1;
	min-width: 0;
}

.card-calendar__header {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.card-calendar__subject {
	font: 400 0.875rem "Lato", sans-serif;
	color: #979797;
	margin: 0.35rem 0 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.card-calendar__type-badge {
	display: inline-flex;
	align-items: center;
	font-size: 0.85rem;
	font-weight: 500;
	padding: 0.25rem 0.85rem;
	border-radius: 20px;
	background: #f1f3f4;
	color: #495057;
}

.card-calendar__type-badge--visio {
	background: rgba(139, 69, 19, 0.1);
	color: #8b4513;
}

.card-calendar__type-badge--rdv {
	background: rgba(59, 130, 246, 0.1);
	color: #3b82f6;
}

.card-calendar__type-badge--phone {
	background: rgba(239, 68, 68, 0.1);
	color: #ef4444;
}
</style>


// WEBPACK FOOTER //
// CardCalendar.vue?c1b312e8